export default __webpack_public_path__ + "static/media/chi.da6e6897.jpg";